import { render } from "./AppDashboard.vue?vue&type=template&id=c25a6802&scoped=true"
import script from "./AppDashboard.vue?vue&type=script&lang=js"
export * from "./AppDashboard.vue?vue&type=script&lang=js"

import "./AppDashboard.vue?vue&type=style&index=0&id=c25a6802&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c25a6802"]])

export default __exports__